var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 9.30748V5.88002C1.875 4.98752 2.4225 4.19248 3.255 3.87748L9.21 1.62748C10.14 1.27498 11.1375 1.96501 11.1375 2.96251V5.8125M5.25 8.99994H10.5M13.53 10.1624C13.215 10.4699 13.035 10.9124 13.08 11.3849C13.1475 12.1949 13.89 12.7874 14.7 12.7874H16.125V13.6799C16.125 15.2324 14.8575 16.4999 13.305 16.4999H4.695C3.1425 16.4999 1.875 15.2324 1.875 13.6799V8.63245C1.875 7.07995 3.1425 5.81244 4.695 5.81244H13.305C14.8575 5.81244 16.125 7.07995 16.125 8.63245V9.71245H14.61C14.19 9.71245 13.8075 9.87743 13.53 10.1624ZM16.9191 10.4776V12.0226C16.9191 12.4351 16.5891 12.7726 16.1691 12.7876H14.6991C13.8891 12.7876 13.1466 12.1951 13.0791 11.3851C13.0341 10.9126 13.2141 10.4701 13.5291 10.1626C13.8066 9.87757 14.1891 9.71259 14.6091 9.71259H16.1691C16.5891 9.72759 16.9191 10.0651 16.9191 10.4776Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c2d2120c4a45b3145a5ffe9a3acdbe0c.svg";
export { ForwardRef as ReactComponent };